/* eslint-disable @typescript-eslint/no-explicit-any */
import { List, Stack, Typography } from '@mui/material';
import Cal, { getCalApi } from '@calcom/embed-react';
import {useEffect, useState} from 'react';

enum CalIDs {
one = 'welcome-call-mon-tue',
two = 'welcome-call-tue-wed',
three = 'welcome-call-wed-thu',
four = 'welcome-call-thu-fri',
five = 'welcome-call-fri-sat',
six = 'welcome-call-sat-mon',
}
async function calInit(calID: string) {
if (!calID) return;
const cal = await getCalApi({ namespace: calID });
cal('ui', {
    theme: 'dark',
    cssVarsPerTheme: {
        light: { 'cal-brand': '#191919' },
        dark: { 'cal-brand': '#f4f4f4' },
    },
    hideEventTypeDetails: false,
    layout: 'week_view',
});
}

function WelcomCallFYM() {
const welcomCallData = sessionStorage.getItem('welcomCallData');
const parsed = welcomCallData ? JSON.parse(welcomCallData) : {};
const [calID, setCalID] = useState<string | undefined>(parsed.calID );
const calName = parsed.name || '';
const calEmail = parsed.email || '';

useEffect(() => {
    if (!calID) {
        const today = new Date();
        const day = today.getDay();
        switch (day) {
            case 1: setCalID('one'); break;
            case 2: setCalID('two'); break;
            case 3: setCalID('three'); break;
            case 4: setCalID('four'); break;
            case 5: setCalID('five'); break;
            case 6: setCalID('six'); break;
            default: setCalID('one'); break;
        }
    }
}, []);

useEffect(() => {
    if (calID) {
        calInit(calID);
    }
}, [calID]);

return (
<Stack
alignItems="stretch"
minHeight={'calc(100vh - 6.4rem)'}
justifyContent={'center'}
pt={4}>
<Stack
gap={6}
px={4}
alignItems="center"
justifyContent={'center'}
width={'100%'}>
<Typography variant="h1">Schedule Your Welcome Call</Typography>
<Stack
className="tprx-card"
direction={{ xs: 'column', md: 'row' }}
width={'100%'}
maxWidth={'144rem'}
alignItems={'center'}
justifyContent={'center'}
gap={8}>
<List
sx={{
  backgroundColor: 'transparent',
  border: 'none',
  listStyleType: 'disc',
  pl: 4,
  width: '100%',
  maxWidth: '60ch',
  display: 'flex',
  gap: '2rem',
  flexDirection: 'column',
  alignSelf: 'center',
}}>
<li>
  The process for obtaining medications{' '}
  <strong>directly from the manufacturer is different</strong> from
  what you may be used to with your pharmacy or insurance. This is
  why the Welcome Call is so important.
</li>
<li>
  Discuss your goals and how we can assist you on the call, we will
  guide you step-by-step so you understand
  <strong> exactly what to do, what documents</strong> you’ll need
  to bring to your doctor, and how to make this process as
  <strong> straightforward as possible.</strong>
</li>
<li>
  You will receive <strong> reminder texts </strong>for this call.
  Please do not miss it — it is important for you.
</li>
</List>
<Cal
namespace={CalIDs[calID as keyof typeof CalIDs]}
calLink={`team/tprx/${
  CalIDs[calID as keyof typeof CalIDs]
}?name=${encodeURIComponent(calName)}&email=${encodeURIComponent(
  calEmail
)}`}
style={{
  width: '100%',
  height: '100%',
  overflowY: 'scroll',
  maxHeight: '70vh',
}}
config={{ layout: 'column_view', theme: 'light' }}
/>
</Stack>
</Stack>
</Stack>
);
}

export default WelcomCallFYM;
